

import Vue from "vue"
import App from "./App"
import router from "./router"
import store from "./store"



import "@/styles/index.css"

require ("@/assets/icon/icon.js")

import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Range from 'vux/src/components/range/index.vue'


Vue.component("x-button", XButton);
Vue.component("cell", Cell)
Vue.component("group", Group)
Vue.component("x-switch", XSwitch)
Vue.component("selector", Selector)
Vue.component("x-dialog", XDialog)
Vue.component("range", Range)

Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)

import init_msg from "@/utils/msg"

init_msg(Vue)
import init_axios from "@/utils/axios"

init_axios(Vue)

import Info from '@/components/info/index'
Vue.use(Info)

import Dialog from '@/components/dialog/index'
Vue.use(Dialog)

Vue.config.productionTip = false;


global.api = require("./api.js");

global.constant = require("./utils/constant");

global.funcset = require("./utils/funcset");

/* eslint-disable no-new */
new Vue({
el: "#app",
router,
store,
template: "<App/>",
components: {App},
methods: {
/*
获取平台限时信息并进行对应的提示
当有选择学校时才进行获取对应限时信息及提示
*/
async deadline_info() {
while (true) {
let current_school_url = localStorage.getItem("current_school_url")
if (!current_school_url) {

await funcset.sleep(4000)
continue
}
await this.$http.get(api.deadline_info_url).then((resp) => {
if (resp.data.success) {
let data = resp.data.data
if (data.is_notify) {
this.$vux.confirm.show({
title: "续费提醒",
content: data.notify_msg,
confirmText: "确定",
showCancelButton: false
});
}
}
}).catch((err) => {})
return
}
},


get_arg(name) {
var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
var r = window.location.search.substr(1).match(reg);
if (r != null) return unescape(r[2]);
return null;
},

ticket_login() {
let ticket = this.get_arg("ticket");

if (!ticket) {
return;
}

if (localStorage.ticket === ticket) {
return;
}


let organization = this.get_arg("organization")


this.$vux.loading.show({text: "登录中.."});

localStorage.clear();


let post_data = {ticket: ticket}

let current_school_url

let api_url


if (organization === "xxcx") {

let access_url = this.get_arg("access_url")
if (!access_url) {
this.msg.toast("登录错误 access_url字段缺失", "text", "top", "20em");
return
}
let schoolid = this.get_arg("schoolid")
if (!schoolid) {
this.msg.toast("登录错误 schoolid字段缺失", "text", "top", "20em");
return
}
let usertype = this.get_arg("usertype")
let userid = this.get_arg("userid")

post_data.access_url = access_url
post_data.schoolid = schoolid
post_data.usertype = usertype
post_data.userid = userid

current_school_url = access_url
api_url = api.loginsso_xxcx_url

} else {

current_school_url = "https://sciot-fsql.tecxen.com"
api_url = api.loginsso_url
}


localStorage.setItem('current_school_url', current_school_url);


this.$http.defaults.baseURL = current_school_url;

this.$http.post(api_url, post_data).then((resp) => {
if (resp.data.success) {
let token = resp.data.data;
let username = resp.data.username;
let version = resp.data.version;
localStorage.setItem('token', token);
localStorage.setItem('username', username);
localStorage.setItem('version', version);
localStorage.setItem('ticket', ticket);
this.$http.defaults.headers.common['Authorization'] = localStorage.getItem('token');
let redirect = decodeURIComponent('/');
this.$router.push(redirect);

} else {
this.$router.push('/login');
this.msg.toast(resp.data.data, 'text', 'top');
}
}).catch((err) => {
this.msg.toast("请求失败", 'text', 'top');
}).finally(() => {
this.$vux.loading.hide()
})
},
},
created() {
this.deadline_info()
this.ticket_login();










localStorage.setItem("doing_scene", "null")
}
})



// WEBPACK FOOTER //
// ./src/main.js